import { config } from '@/pageConfig/homeowners/us/en';
import { HomeownersPageTemplate } from '@/pageTemplate/HomeownersPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomeownersPage() {
  const { trackEvent } = useAnalyticsContext();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(
    () =>
      trackEvent('homeowners_page.viewed', {
        experiment: 'bottom_sticky_cta_off',
      }),
    [],
  );

  return <HomeownersPageTemplate config={config} />;
}
